import React, { useState, useEffect } from "react";
import EnquiryForm from "../../components/shared/enquiryForm/enquiryForm";
import "./homeEnquiryPopup.css";

/**
 * Sticky "Enquire Now" button + auto-opening popup, no close button.
 * Used on Home ("/"), Utsav ("/utsav") and Gowri Anandham ("/gowri-anandham").
 * Pass `source` / `referrer` so each page's leads are tagged correctly in
 * Sell.do; defaults keep the original Home-page behaviour unchanged.
 */
const HomeEnquiryPopup = ({
  source = "Home Page Popup Form",
  referrer = "https://anandhamplots.com/",
  campaignName,
}) => {
  const [show, setShow] = useState(false);

  const handleOpen = () => {
    window.scrollTo({ top: 0, behavior: "smooth" });
    setShow(true);
  };

  const handleClose = () => setShow(false);

  // Auto-open the popup once, as soon as the page first loads.
  useEffect(() => {
    setShow(true);
  }, []);

  // Lock background scroll while the popup is open
  useEffect(() => {
    document.body.style.overflow = show ? "hidden" : "";
    return () => {
      document.body.style.overflow = "";
    };
  }, [show]);

  return (
    <>
      <button
        type="button"
        className="home-sticky-enquiry-btn"
        onClick={handleOpen}
      >
        Enquire Now
      </button>

      {show && (
        <div className="home-enquiry-overlay">
          <div
            className="home-enquiry-popup-wrap"
            onClick={(e) => e.stopPropagation()}
          >
            {/* <button
              type="button"
              className="home-enquiry-close-btn"
              onClick={handleClose}
              aria-label="Close"
            >
              &times;
            </button> */}
            <EnquiryForm
              source={source}
              referrer={referrer}
              campaignName={campaignName}
              onSuccess={() => setShow(false)}
            />
          </div>
        </div>
      )}
    </>
  );
};

export default HomeEnquiryPopup;
